import React from 'react';
import Icon from './Icon';

const stageIconNames = ['fileText', 'search', 'checkCircle', 'arrowRight', 'timer', 'checkCircle', 'fileText', 'rocket'];

const formatDate = (value) =>
  value
    ? new Date(value).toLocaleDateString('en-IN', { day: 'numeric', month: 'short', year: 'numeric' })
    : null;

// Stage-by-stage progress list, shared by the public application tracker
// (TrackApplicationStatus) and the vendor dashboard - both render the same
// ApplicationTrackingResponse.stages shape returned by the backend.
const ApplicationTimeline = ({ stages }) => (
  <ol className="list-none p-0 m-0">
    {stages.map((stage, index) => {
      const isCompleted = stage.status === 'completed';
      const isCurrent = stage.status === 'current';
      const isLast = index === stages.length - 1;
      const date = formatDate(stage.date);

      let dateLabel = 'Pending';
      if (isCompleted) dateLabel = date ? `Completed on ${date}` : 'Completed';
      else if (isCurrent) dateLabel = date ? `Started on ${date}` : 'In progress';

      const nodeBg = isCompleted ? '#16a34a' : isCurrent ? '#2d2a24' : 'var(--zg-card)';
      const nodeBorder = isCompleted ? '#16a34a' : isCurrent ? '#2d2a24' : 'var(--zg-border2)';
      const nodeFg = isCompleted || isCurrent ? '#fff' : 'var(--zg-border2)';
      const lineColor = isCompleted ? '#16a34a' : 'var(--zg-border)';

      return (
        <li key={stage.label} className="flex gap-5">
          <div className="flex flex-col items-center">
            <span
              className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-full border"
              style={{ background: nodeBg, borderColor: nodeBorder, color: nodeFg }}
            >
              {isCompleted ? (
                <Icon name="checkCircle" size={18} color="#fff" />
              ) : (
                <Icon
                  name={stageIconNames[index] || 'checkCircle'}
                  size={18}
                  style={isCurrent ? { animation: 'pulse2 2s ease-in-out infinite' } : undefined}
                />
              )}
            </span>
            {!isLast && <span className="w-0.5 flex-1 my-1" style={{ background: lineColor }} />}
          </div>

          <div className={isLast ? 'pt-2 pb-4' : 'pt-2 pb-9'}>
            <div className="flex flex-wrap items-center gap-2">
              <p className="font-semibold" style={{ color: isCompleted || isCurrent ? 'var(--zg-ink)' : 'var(--zg-muted2)' }}>
                {stage.label}
              </p>
              {isCurrent && (
                <span className="text-xs font-medium text-white px-2 py-0.5 rounded-full" style={{ background: '#2d2a24' }}>
                  In Progress
                </span>
              )}
            </div>
            <p className="text-xs mt-1 uppercase tracking-wide" style={{ color: 'var(--zg-muted2)' }}>
              {dateLabel}
            </p>
          </div>
        </li>
      );
    })}
  </ol>
);

export default ApplicationTimeline;
